import { render, staticRenderFns } from "./ContextMenuBase.vue?vue&type=template&id=3b9c044d&scoped=true&lang=pug"
import script from "./ContextMenuBase.vue?vue&type=script&lang=js"
export * from "./ContextMenuBase.vue?vue&type=script&lang=js"
import style0 from "./ContextMenuBase.vue?vue&type=style&index=0&id=3b9c044d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c044d",
  null
  
)

export default component.exports